







export default {
    data() {
        return {
            active: false,
        };
    },
    methods: {
        click(this: any) {
            this.active = !this.active;
            this.$emit('click');
        },
    },
};
